function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleansingWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m68.2 65.12c0 3.77-2.77 8.75-9.59 8.75s-9.6-5-9.6-8.75c0-6.54 9.6-15.57 9.6-15.57s9.59 9.03 9.59 15.57z",
    style: {
      fill: "#fff",
      strokeWidth: 2,
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,70.25a5.71,5.71,0,0,1-4.43-.39,4.91,4.91,0,0,1-2.91-3.09",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      strokeWidth: "1.5px",
      stroke: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.52,20l1.21,4.26a1.13,1.13,0,0,0,1.39.78l32.46-9.19a1.13,1.13,0,0,0,.78-1.39l-1.21-4.27a1.13,1.13,0,0,0-1.39-.77L14.3,18.56A1.14,1.14,0,0,0,13.52,20Zm2.48.47,30.29-8.58.59,2.1L16.59,22.52Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.82,41.41H14.13a1,1,0,0,1-1-1V31a1,1,0,0,1,1-1h3.69l2.23,0V24.48a1,1,0,0,1,1-1h13.7a1,1,0,0,1,1,1v4.74c0,.8.36.74.62.74h20c3.28,0,8.25,2.07,8.25,7.24v9.25a1,1,0,0,1-1,1H54.11a1,1,0,0,1-1-1V42.29c0-1.63-1.33-.88-3-.88H27.82Zm19.55-2h2.77c2.74,0,5,.14,5,2.87v3.17h7.48V37.2c0-2.9-2.35-5.26-7.38-5.26H37.37l-3,0c-.55,0-.63-.36-.63-.65V25.47H22v4.79a2.07,2.07,0,0,1-.28,1.23,1,1,0,0,1-.56.36,20.27,20.27,0,0,1-2.77.09h-3.3v7.48H47.37Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.3 29.94h14.45v1.99h-14.45z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.62 24.31h-6.19v-2.5l6.19-1.53z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      stroke: "currentColor"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleansingWater);
export default __webpack_public_path__ + "static/media/cleansing_water.f32f1b385cdb9c0f496a9867320f348a.svg";
export { ForwardRef as ReactComponent };